export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';
export const SET_CRITICAL_ERROR = 'SET_CRITICAL_ERROR';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';